import is from '@/utils/is';
import { removeUndefinedKeys } from '@/utils/object';
import { useCallback } from 'react';

const transformEventPropsForWE = (props: any) => {
  const {
    customerId,
    product_code,
    product_segment,
    amc_due_date,
    amc_status,
    asset_id,
    is_rental,
    platform,
    product_name,
    product_technology,
    total_ewp_asset_count,
    total_owned_asset_count,
    plan_visible,
    price,
    utm_source,
    utm_campaign,
    utm_channel,
    utm_term,
    utm_medium,
    plan_duration_selected,
    planType,
    plan_id,
    technician_code,
    discount,
    coupon,
    item_subcategory,
    size,
    color,
    in_stock,
    exchange_applied,
    exchange_value,
    item_id,
    item_name,
    quantity,
    cart_value,
    items,
    pincode,
    city,
    state,
    ...restProps
  } = props;
  const transformedProps: any = {
    ...restProps,
    customer_id: customerId,
    device_category: product_segment,
    component_id: product_code,
    duration: plan_duration_selected,
    amc_due_date: new Date(amc_due_date),
    amc_status,
    asset_id,
    is_rental,
    platform,
    product_name,
    product_technology,
    total_ewp_asset_count,
    total_owned_asset_count,
    plan_visible,
    utm_source,
    utm_campaign,
    utm_channel,
    utm_term,
    utm_medium,
    price,
    currency: 'INR',
    plan_selected: planType,
    plan_id,
    discount,
    technician_code,
    coupon,
    item_subcategory,
    size,
    color,
    in_stock,
    exchange_applied,
    exchange_value,
    item_id,
    item_name,
    quantity,
    cart_value,
    items,
    pincode,
    city,
    state,
  };
  return removeUndefinedKeys(transformedProps);
};

const useWebEngage = () => {
  const fireWebEngageEvent = useCallback(
    (eventProps: any, { isDirect }: { isDirect?: boolean }) => {
      const eventProperties = { ...eventProps };
      if (isDirect) {
        eventProperties.event = `direct_${eventProperties.event}`;
      }
      const webengage = window.webengage;

      if (is.client() && webengage && webengage.track) {
        const transformedProps = transformEventPropsForWE(eventProperties);
        webengage.track(eventProperties.event, transformedProps);
        if (is.dev()) {
          console.log(
            'WebEngage EVENT: ' + eventProperties.event + ' triggered!',
            transformedProps,
          );
        }
      } else {
        console.warn('Either webengage is not loaded or webEngage is not enabled!');
      }
    },
    [],
  );
  return { fireWebEngageEvent };
};

export default useWebEngage;
